import { ReactNode } from 'react';

import { cn } from 'support/helpers/cn/cn';
import { Severity } from 'support/types/ui';

export const AlertSection = ({
  title,
  children,
  severity,
  className,
}: {
  title: string | null;
  children?: ReactNode;
  severity: Severity;
  className?: string;
}) => {
  return (
    <div>
      {title && <h4 className={cn('font-semibold', titleClasses[severity])}>{title}</h4>}
      {children ? <div className={cn(className, 'mt-1 text-gray-900')}>{children}</div> : null}
    </div>
  );
};

const titleClasses: Record<Severity, string> = {
  error: 'text-red-700',
  warning: 'text-warning-700',
  info: 'text-info-700',
  success: 'text-success-700',
  neutral: 'text-neutral-700',
};
